import {get} from './base.service'
import {post} from './base.service'
export default{
    getUserInfo(){
        return get('/app/user/info');
    },
    editUserInfo(params){
        return post('/app/user/modify',params);
    }
}


// WEBPACK FOOTER //
// ./src/service/personal.service.js